
import Portal from "../../../../../platform/pages/business/portal";
import BookingTypeEntryFormHeader from "./bookingTypeEntryFormHeader"

const CreateNewDashBoard = (props) => {
  return <Portal TabComponent={BookingTypeEntryFormHeader} title={"BookingTypes"} props={props} />;
};
export default CreateNewDashBoard;
